import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE = "https://guiadejampa.com";

/**
 * Reusable breadcrumb.
 * items: [{ name: "Empresas", to: "/empresas" }, { name: "Restaurante X" }]
 * The last item is treated as the current page (no link, has aria-current).
 * Emits BreadcrumbList JSON-LD automatically.
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items?.length) return null;
  const withHome = [{ name: "Início", to: "/" }, ...items];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: withHome.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name,
      ...(it.to ? { item: `${SITE}${it.to}` } : {}),
    })),
  };
  // Safe JSON-LD: React children escape < and >, avoiding XSS via dangerouslySetInnerHTML.
  return (
    <nav aria-label="breadcrumb" className="text-xs text-muted-foreground" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1">
        {withHome.map((it, i) => {
          const last = i === withHome.length - 1;
          const key = `${it.to || "current"}-${it.name}-${i}`;
          return (
            <li key={key} className="flex items-center gap-1">
              {last || !it.to ? (
                <span aria-current={last ? "page" : undefined} className={last ? "text-foreground font-medium" : ""}>{it.name}</span>
              ) : (
                <Link to={it.to} className="hover:text-primary">{it.name}</Link>
              )}
              {!last && <ChevronRight className="w-3 h-3" />}
            </li>
          );
        })}
      </ol>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </nav>
  );
}
